export const entiteCode = 'archivage';

export class Roles {
  static readonly gestionnaire: string = `gestionnaire_${entiteCode}`;
  static readonly superviseur: string = `superviseur_${entiteCode}`;
  static readonly admin: string = `admin_${entiteCode}`;
}
